// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3nwIF","content":"styles_content__2e6y4","checkbox":"styles_checkbox__3XW5X","checkboxLabel":"styles_checkboxLabel__3TEZu"};